<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="buyLicence"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="licence modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body pb-4">
            <div
              class="d-flex justify-content-between mx-0 px-2 pb-2 mb-5"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <h5 class="">{{ $t("choose-plan") }}</h5>

              <p class="cursor-pointer" @click="close">
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>
            <!-- Notification -->
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>

            <div class="mb-4 tab_">
              <p
                class="d-inline-block"
                :class="{ active: !yearly }"
                @click="yearly = false"
              >
                {{ $t("monthly") }}
              </p>
              <p
                class="d-inline-block ml-3"
                :class="{ active: yearly }"
                @click="yearly = true"
              >
                {{ $t("annually") }}
              </p>
            </div>
            <!-- Cards -->
            <div class="d-flex flex-wrap justify-content-between">
              <div
                v-for="(plan, i) in plans"
                :key="i"
                class="card-container mb-4"
              >
                <div class="licence-card">
                  <p>{{ plan.name }}</p>
                  <p class="price" v-if="yearly">
                    NGN {{ (12 * plan.price).toLocaleString() }}
                    <span> /{{ $t("annually-small") }}</span>
                  </p>
                  <p class="price" v-else>
                    NGN {{ plan.price.toLocaleString() }}
                    <span> /{{ $t("monthly-small") }}</span>
                  </p>

                  <p class="py-2">
                    {{ plan.description }}
                  </p>

                  <div v-for="(value, key, i) in plan.features" :key="i">
                    <div v-if="value !== true" class="d-flex mb-2">
                      <GreenCheck />
                      <!-- <p class="ml-2">{{ value }} months Data Retention</p> -->
                      <p class="ml-2">
                        {{ $t("data-retention", { value: value }) }}
                      </p>
                    </div>
                    <div
                      class="d-flex mb-2"
                      style="text-transform: capitalize;"
                      v-if="value && key !== 'location' && key !== 'haas'"
                    >
                      <GreenCheck />
                      <p class="ml-2">
                        {{ key }}
                      </p>
                    </div>
                    <div
                      class="d-flex mb-2"
                      style="text-transform: capitalize;"
                      v-if="value && key === 'location'"
                    >
                      <GreenCheck />
                      <p class="ml-2">
                        {{ $t("location-maps-geofence-poi") }}
                      </p>
                    </div>
                    <div
                      class="d-flex mb-2"
                      style="text-transform: capitalize;"
                      v-if="value && key === 'haas'"
                    >
                      <GreenCheck />
                      <p class="ml-2">
                        {{ $t("hardware-as-a-service") }}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex align-items-center mt-3 justify-content-center col-gap-1 mb-3"
                >
                  <p class="m-0" v-if="yearly">{{ $t("yearly-text") }}</p>
                  <p class="m-0" v-else>{{ $t("monthly-text") }}</p>
                  <span
                    class="d-flex align-items-center"
                    style="column-gap:0.5rem"
                  >
                    <span
                      @click="handleArrow(i, 'descrease', 'months')"
                      :class="{ 'cursor-pointer': plansData[i].value > 0 }"
                    >
                      <ArrowBack />
                    </span>
                    <input
                      type="text"
                      :value="plansData[i].value"
                      placeholder="1"
                      @input="updateVal($event, i)"
                      min="1"
                      @keypress="IsNumber($event)"
                    />
                    <span
                      @click="handleArrow(i, '', 'months')"
                      class="cursor-pointer"
                    >
                      <ArrowForward />
                    </span>
                  </span>
                </div>
                <div
                  class="d-flex align-items-center mt-3 justify-content-center col-gap-1 mb-3"
                >
                  <p class="m-0 pr-3">{{ $t("number-of-devices") }}</p>
                  <span
                    class="d-flex align-items-center"
                    style="column-gap:0.5rem"
                  >
                    <span
                      @click="handleArrow(i, 'descrease', 'devices')"
                      :class="{ 'cursor-pointer': plansData[i].devices > 0 }"
                    >
                      <ArrowBack />
                    </span>
                    <input
                      type="text"
                      :value="plansData[i].devices"
                      placeholder="1"
                      @input="updateDevices($event, i)"
                      min="1"
                      @keypress="IsNumber($event)"
                    />
                    <span
                      @click="handleArrow(i, '', 'devices')"
                      class="cursor-pointer"
                    >
                      <ArrowForward />
                    </span>
                  </span>
                </div>
                <div class="d-flex justify-content-center" v-if="yearly">
                  Total = &nbsp;
                  <p class="price">
                    NGN
                    {{
                      (
                        12 *
                        plansData[i].priceNum *
                        plansData[i].value *
                        plansData[i].devices
                      ).toLocaleString()
                    }}
                  </p>
                </div>
                <div class="d-flex justify-content-center" v-else>
                  Total = &nbsp;
                  <p class="price">
                    NGN
                    {{
                      (
                        plansData[i].priceNum *
                        plansData[i].value *
                        plansData[i].devices
                      ).toLocaleString()
                    }}
                  </p>
                </div>
                <button
                  class="btn btn-primary d-flex justify-content-center"
                  @click="
                    $emit('openBill', getPrice(i, plansData[i], plan._id))
                  "
                  :disabled="
                    Number(plansData[i].value) < 1 ||
                      Number(plansData[i].devices) < 1
                  "
                >
                  {{ $t("choose-plan-short") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";
import GreenCheck from "../../components/Iconsvg/GreenCheck.vue";
import ArrowForward from "../../components/Iconsvg/ArrowForward.vue";
import ArrowBack from "../../components/Iconsvg/ArrowBack.vue";

export default {
  name: "BuyLicence",
  props: {
    show: Boolean,
    plans: Array,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      fullname: "",
      email: "",
      role: "",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      iti: "",
      selectNotification: "",
      yearly: false,

      plansData: this.plans.map((plan) => ({
        value: 1,
        priceNum: plan.price,
        devices: 1,
      })),
      formatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }),
    };
  },
  components: {
    Loading,
    GreenCheck,
    ArrowForward,
    ArrowBack,
  },
  mounted() {
    // this.initialiseForm();
  },
  watch: {
    user: {
      handler: function() {
        this.initialiseForm();
      },
      deep: true,
    },
    fullname: {
      handler() {
        if (/^[a-zA-Z\s]*$/.test(this.fullname))
          return (this.selectNotification = "");
        else this.selectNotification = this.$t("must_contain");
      },
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["editUser", "getUsers"]),
    onCancel() {
      this.$emit("closeEditUserModal");
    },
    getPrice(i, planInfo, planId) {
      let data = {};
      if (this.yearly) {
        data.totalPrice =
          12 *
          this.plansData[i].priceNum *
          this.plansData[i].value *
          this.plansData[i].devices;
        data.months = planInfo.value * 12;
      } else {
        data.totalPrice =
          this.plansData[i].priceNum *
          this.plansData[i].value *
          this.plansData[i].devices;
        data.months = planInfo.value;
      }
      data.devices = planInfo.devices;
      data.planid = planId;
      return data;
    },
    initialiseForm() {
      setTimeout(() => {
        this.fullname = this.user[0].fullname;
        var input = document.querySelector("#phone_number");
        this.iti = intlTelInput(input, {
          separateDialCode: true,
          utilsScript: utils,
        });
        var number = "+" + this.user[0].phone.toString();
        // console.log(number, "iti setting number valid");
        this.iti.setNumber(number);
        // console.log(this.iti.isValidNumber(), "number validation");
        // console.log(this.iti, "checking iti presence");
        if (!this.iti.isValidNumber()) {
          number =
            "+" +
            this.user[0].countryCode.toString() +
            this.user[0].phone.toString();
          // console.log((number))
          // console.log(number, "iti setting number country code")
          this.iti.setNumber(number);
        }
        this.email = this.user[0].email;
        this.role = this.user[0].role;
      }, 200);
    },
    adduser() {
      let number = this.iti.getNumber().slice(1);
      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = this.$t("valid_phone");
      } else {
        this.isLoading = true;
        this.Errormssg = "";
        const newUser = {
          phone: parseInt(number),
          fullname: this.fullname,
          role: this.role,
        };
        this.editUser({ newUser, id: this.user[0]._id })
          .then((res) => {
            // console.log(res, "res after edit");
            this.getUsers().then(() => {
              this.onCancel();
            });
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            setTimeout(() => {
              this.isLoading = true;
            }, 1000);
          })
          .catch((error) => {
            // console.log(error, "error after edit");

            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
    close() {
      this.$emit("closeLicence");
    },
    updateVal(val, i) {
      let temp = [...this.plansData];
      temp[i].value = Number(val.target.value);
      this.plansData = temp;
    },
    updateDevices(val, i) {
      let temp = [...this.plansData];
      temp[i].devices = Number(val.target.value);
      this.plansData = temp;
    },
    IsNumber(event) {
      if (!/^[0-9]\d*(\.\d+)?$/.test(event.key)) return event.preventDefault();
    },
    handleArrow(i, action, name) {
      let temp = [...this.plansData];
      if (name === "months") {
        if (action === "descrease") {
          if (temp[i].value <= 0) return;
          temp[i].value = temp[i].value - 1;
        } else temp[i].value = temp[i].value + 1;
        this.plansData = temp;
      } else {
        if (action === "descrease") {
          if (temp[i].devices <= 0) return;
          temp[i].devices = temp[i].devices - 1;
        } else temp[i].devices = temp[i].devices + 1;
        this.plansData = temp;
      }
    },
  },
};
</script>

<style scoped>
.licence.modal-dialog {
  max-width: 1000px !important;
}
.licence-card {
  background: #ffffff;
  box-shadow: 0px 4px 40px 3px rgba(0, 0, 0, 0.07);
  border-radius: 2px;
  padding: 20px;
  width: 290px;
  position: relative;
  /* padding-bottom: 65px; */

  display: flex;
  flex-flow: column;
  min-height: 32rem;
  /* justify-content: space-between; */
}
.d-flex button {
  /* padding: 5px 20px; */
  /* position: absolute; */
  bottom: 20px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
}
.licence-card p:first-child {
  color: #213e7a;
  font-weight: 500;
  font-size: 16px;
}
.licence-card .price,
.price {
  color: #213e7a;
  font-size: 24px;
}
.licence-card .price span {
  font-size: initial;
  color: #222222;
}
input {
  background: #ffffff;
  border: 1px solid #213e7a;
  box-sizing: border-box;
  border-radius: 4px;
  width: 2.5rem;
  height: 1.7rem;
  text-align: center;
}
input::placeholder {
  color: #b7c3cd;
}
.tab_ p {
  color: #404a57;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 10px;
  /* transition: 0.5s ease-in-out; */
}
.tab_ p:hover {
  color: #213e7a;
  border-bottom: 1px solid #213e7a;
}
.tab_ p.active {
  color: #213e7a;
  border-bottom: 1px solid #213e7a;
}
@media (max-width: 576px) {
  .modal-dialog {
    width: 100%;
  }
  .licence-card {
    width: 90% !important;
    min-height: 28rem;
    margin-left: auto;
    margin-right: auto;
  }
  .card-container {
    margin-bottom: 2rem;
    width: 100%;
  }
  .d-flex button {
    width: 70%;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<i18n>
{
	"en": {
		"add_user": "Add a User",
		"all_users": "All Users",
		"edit_user": "Edit User",
		"email": "Email",
		"full_name": "Full Name",
		"man_user_right": "Manage user rights for members of your business",
		"manage": "Manager",
		"must_contain": "Must conain only Letters",
		"name": "Name",
		"phone": "Phone Number",
		"staff": "Staff",
		"user_rights": "User Rights",
		"valid_phone": "This phone number is not valid"
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"all_users": "Tous les utilisateurs",
		"edit_user": "Modifier l'utilisateur",
		"email": "E-mail",
		"full_name": "Nom et prénom",
		"man_user_right": "Gérez les droits d'utilisation des membres de votre entreprise",
		"manage": "Directeur",
		"must_contain": "Ne doit contenir que des lettres",
		"name": "Nom",
		"phone": "Numéro de téléphone",
		"staff": "Personnel",
		"user_rights": "Droits de l'utilisateur",
		"valid_phone": "Ce numéro de téléphone n'est pas valide"
	},
	"sw": {
		"add_user": "ONGEZA MTUMIAJI",
		"all_users": "Watumiaji Wote",
		"edit_user": "Badilisha mtumiaji",
		"email": "Barua pepe",
		"full_name": "Jina kamili",
		"man_user_right": "Dhibiti haki za mtumiaji za wanachama wa biashara yako",
		"manage": "Meneja",
		"must_contain": "Lazima iwe na Barua tu",
		"name": "Jina",
		"phone": "Nambari ya simu",
		"staff": "STAFF",
		"user_rights": "Haki za Mtumiaji",
		"valid_phone": "Nambari hii ya simu si sahihi"
	}
}
</i18n>
